import { render, staticRenderFns } from "./SelectScope.vue?vue&type=template&id=4aa13a10&"
import script from "./SelectScope.vue?vue&type=script&lang=js&"
export * from "./SelectScope.vue?vue&type=script&lang=js&"
import style0 from "./SelectScope.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports